<template>
    <div class="app_container">
        <el-form ref='form' :rules="rules" :model="form" label-width="80px" class="change-form">

            <el-row>
                <el-col :span="24">
                    <el-form-item label="IP" prop='key'>
                        <span>{{form.q}}</span>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24">
                    <el-form-item label="Name" prop='key'>
                        <span>{{form.q}}</span>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24">
                    <span>{{form.q}}</span>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24">
                    <el-form-item label="状态" prop='key'>
                        <span>{{form.q}}</span>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24">
                    <el-form-item label="所属组/部门" prop='key'>
                        <el-input placeholder="请选择参数值" v-model="form.q"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            
            <el-row>
                <el-col :span="24">
                    <el-form-item>
                        <el-button type='primary' @click='SubmitFn("form")'>确定</el-button>
                        <el-button type='info' @click='onCancel'>取消</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    import { getRules } from '../cicd.rules'
    const rules = getRules()

    export default {
        props: {
            type: {
                type: String,
                default: 'add'
            },
            keyList: Array,
            keys: String,
            values: String,
            ind: String,
            callback: Function
        },

        data() {
            return {
                form: {
                    key: this.keyList[0],
                    value: ''
                },
                rules
            }
        },

        created() {
            if (this.type === 'edit') {
                this.$modal.title = '编辑参数'
                this.form.key = this.keys
                this.form.value = this.values
            }
        },
        
        methods: {
            // 点击确定
            SubmitFn(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$modal.close()
                        this.callback(this.form, this.ind)
                    } else {
                        return false;
                    }
                });
            },

            // 点击取消
            onCancel() {
                    this.$modal.close();
                },
        },

    }
</script>
